<div class="membership-profile-validator"
     [ngClass]="validatorClasses()"
     fxLayout="row wrap"
     fxLayout.lt-md="column"
     fxLayoutGap="15px"
     fxFlex="100">

    <!--        -->
    <div class="membership-profile-info" fxFlex="50">

        <!-- Image-->
        <div class="profile-name">
            <h3>{{profile.profileName}}</h3>
        </div>

        <!--            -->
        <div class="profile-image">
            <img [src]="validationImage"
                 alt="Membership profile image">
        </div>

    </div>

    <!--    -->
    <div class="membership-profile-form-section" fxFlex>
        <form class="membership-profile-form"
              [formGroup]="validationFormGroup"
              fxLayout="column">

            <ng-container formArrayName="validationFields">


                <!--                -->
                <div class="form-group"
                     *ngFor="let group of validationFields?.controls ;let i=index ">

                    <ng-container dynamicField
                                  [fields]="validationFieldConfigs"
                                  [group]="group"></ng-container>
                </div>

            </ng-container>

            <!--       Submit Button             -->
<!--            <div class="validate-btn">-->
<!--                <button mat-flat-button-->
<!--                        type="button"-->
<!--                        (click)="onValidateProfile()"-->
<!--                        [color]="isDiscountApplied ? 'warn':'primary'">-->
<!--                    {{(isDiscountApplied ? 'shared.labels.discountApplied' : 'shared.labels.apply')|translate}}-->
<!--                </button>-->
<!--            </div>-->

        </form>
    </div>
</div>
